import { getArtistQueryOptions } from "@/routes/_app/artist/$id/artist-query";
import { prefetchForSsr } from "@/utils/loader";
import { FORMAT_CATEGORIES_WITH_OTHER } from "@garimpa/lib/formatGroups";
import { offersPageState } from "./offers-page-state";
import { getOffersQueryOptions } from "./offers-query";
const OFFER_FORMATS = ["all", ...FORMAT_CATEGORIES_WITH_OTHER] as const;
type OffersSearch = {
  condition?: "new" | "used";
  artistId?: string[];
  cursor?: number;
  format?: (typeof OFFER_FORMATS)[number];
  genre?: string[];
  /** Hidden minimum work popularity score for data inspection. */
  popularity?: number;
  priceMin?: number;
  priceMax?: number;
  sort?: (typeof OFFER_SORTS)[number];
  style?: string[];
  year?: number[];
};

/** Keeps the facet `year` shape: one exact year or a closed [from, to] range. */

type OfferFormat = (typeof OFFER_FORMATS)[number];
const SplitLoader = async ({
  context: {
    locale,
    queryClient,
    viewer
  },
  deps,
  location
}) => {
  const search = location.search as OffersSearch;
  const queryOptions = getOffersQueryOptions({
    ...search,
    currency: viewer.preferences.currency
  });
  const artistId = deps.artistIds?.length === 1 ? deps.artistIds[0] : undefined;
  const artistPromise = artistId ? queryClient.ensureQueryData(getArtistQueryOptions({
    id: artistId,
    locale
  })) : Promise.resolve(null);
  const [artist] = await Promise.all([artistPromise, prefetchForSsr([queryClient.prefetchQuery(queryOptions)])]);
  return offersPageState({
    artistId,
    artist
  });
};
export { SplitLoader as loader };